<template>
  <v-row justify="center" no-gutters>
    <v-col cols="12">
      <v-row justify="center" align="stretch">
        <v-col
          v-if="results.entries.slice(1).length > 0"
          md="4"
          class="d-flex flex-column"
        >
          <!-- Next drawing card  -->
          <div class="card-header"><span>Pick</span> <span>Numbers</span></div>
          <v-card shaped class="secondary-card">
            <v-card-text>
              <result-display
                v-for="result in results.entries.slice(1)"
                :key="result.sortition.id"
                :result="result"
              >
              </result-display>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="4" class="d-flex flex-column">
          <!-- Next drawing card  -->
          <v-img class="align-self-center" width="250" height="100" contain :src="require('assets/static/img/logo/superlotto_white.png')"></v-img>
          <v-card class="flex-grow-1" id="primary-card" shaped>
            <v-card-text>
              <upcoming-sortition
                id="upcoming-result"
                :upcoming-sortition="upcomingSortition"
                @refresh="fetchUpcomingSortition"
              >
              </upcoming-sortition>
              <hr />
              <template v-if="results.entries.slice(0, 1).length > 0">
                <h1 id="winning-numbers-text" class="text-center my-1">
                  Winning numbers
                </h1>
                <result-display
                  v-for="result in results.entries.slice(0, 1)"
                  :key="result.sortition.id"
                  :result="result"
                >
                </result-display>
              </template>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col md="4" class="d-flex flex-column">
          <!-- Playouts card -->
          <div class="card-header">
						<span v-if="showResults">
							Results
						</span>
						<span v-else>
            Payouts
						</span>
          </div>
					<prizes-card
						class="secondary-card"
						v-if="showPrizes"
						:prizes="prizes"></prizes-card>
					<results-card
						class="secondary-card"
						v-if="showResults"
						display-horizontally
						:results-by-lottery="resultsToShow"></results-card>
				</v-col>
      </v-row>
    </v-col>
    <v-col id="page-url" cols="12" class="text-center">
      <span>Visit our page {{ url }}</span>
    </v-col>
  </v-row>
</template>

<script>
import ResultDisplay from "./ResultDisplay.vue";
import UpcomingSortition from "./UpcomingSortition.vue";
import BaseBoard from "../BaseBoard.js";
import PrizesCard from "./PrizesCard.vue";
import ResultsCard from '@/homepage/components/common/ResultsCard.vue';

export default {
  name: "Board",
	extends: BaseBoard,
  components: {
		ResultsCard,
    UpcomingSortition,
    ResultDisplay,
    PrizesCard
  },
};
</script>

<style scoped lang="scss">
$card-background: rgba(#2b55bc, 0.5);

.result-display {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.secondary-card {
  background-color: darken($card-background, 20) !important;
  box-shadow: 8px 6px 20px 0 #07000080;
	border-radius: 30px;
}

.v-card {
  color: white;
  border-radius: 30px;
}

#primary-card {
  background-color: transparent;
  border: 2px solid white;
}

::v-deep .v-card #countdown {
  line-height: 40px;
  text-align: center;
  font-family: "Intro Inline", serif;
}

#winning-numbers-text {
  line-height: 30px;
}

#upcoming-result {
  margin-top: 2px;
  margin-bottom: 2px;
}

.card-header {
  box-shadow: -3px 3px 7px 0px #0000009e;
  font-size: 1.5rem;
  padding: 0 6px;
  margin-bottom: 5px;
  margin-left: 20px;
  margin-right: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  border-radius: 30px;
  background-image: linear-gradient(to right, #fd383b, #c11d1e);
}

#page-url {
  font-size: 2rem;
}
</style>
